import { render, staticRenderFns } from "./AppDatabases.vue?vue&type=template&id=986b6888&scoped=true"
import script from "./AppDatabases.vue?vue&type=script&lang=js"
export * from "./AppDatabases.vue?vue&type=script&lang=js"
import style0 from "./AppDatabases.vue?vue&type=style&index=0&id=986b6888&prod&lang=scss&scoped=true"
import style1 from "./AppDatabases.vue?vue&type=style&index=1&id=986b6888&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "986b6888",
  null
  
)

export default component.exports